import { Injectable } from '@angular/core';
import { CellActionTypes } from 'src/app/components/tables/components/cell-actions.type';
import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { SuggestedUser } from '../../relation-request.interface';
import { UserSearchTableConstructor } from '../search-table';

export const suggestedPatientRowData: (user: SuggestedUser) => GridTableBody = ({
  user,
  patientLinkStatus,
  patient,
}: SuggestedUser) => {
  return {
    user,
    entityId: user.user_id,
    actorId: user.user_id,
    created: null,
    list: patient && patient.diseases.map((disease) => disease.title),
    manage: { status: Boolean(patientLinkStatus), reason: patientLinkStatus && patientLinkStatus.status },
    tooltipValues: { [CellActionTypes.ADD]: 'TOOLTIP_SEND_REQUEST' },
  };
};

@Injectable()
export class SuggestedPatientTable implements UserSearchTableConstructor {
  public buildTableData(items: SuggestedUser[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.DISEASES, ColumnTypes.DATE, ColumnTypes.MANAGE];
  }

  private getManageCellAttribute(): TableCellAttribute {
    return { value_class_front: 'manageRelation', key: 'manage' };
  }

  private getTableBody(items: SuggestedUser[]): GridTableBody[] {
    return items.map(suggestedPatientRowData);
  }
}
